import { formatDistanceToNowStrict } from 'date-fns/formatDistanceToNowStrict';
import { ru } from 'date-fns/locale';

export default function distanceToNow(dateTime: number | Date) {
  return formatDistanceToNowStrict(new Date(dateTime), {
    addSuffix: true,
    locale: ru
  });
}
